import styled from 'styled-components'

const Wrapper = styled.div`
  display: block;
  width: 100%;
  white-space: nowrap;
  padding-bottom: 10px;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].sm}) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`

export { Wrapper } // eslint-disable-line
